import React from 'react';
import PropTypes from 'prop-types';
import isUndefined from 'lodash/isUndefined';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { Apps, People, List } from '@mui/icons-material';

import {
  READ, MARKET_PAGE, REPORTS_PAGE, USER_ADMIN,
} from '../../access';

const styles = {
  menuLink: {
    textDecoration: 'none',
  },
};

function MainMenu({ currentWrangler: user }) {
  if (isUndefined(user)) {
    return (<div />);
  }
  return (
    <div>
      {user.access.can(READ, MARKET_PAGE) && (
      <Link to="/operator/markets" style={styles.menuLink}>
        <MenuItem>
          <ListItemIcon>
            <Apps />
          </ListItemIcon>
          <ListItemText inset primary="Markets" />
        </MenuItem>
      </Link>
      )}
      {user.access.can(READ, USER_ADMIN) && (
      <Link to="/operator/users" style={styles.menuLink}>
        <MenuItem>
          <ListItemIcon>
            <People />
          </ListItemIcon>
          <ListItemText inset primary="Field Workers" />
        </MenuItem>
      </Link>
      )}
      {user.access.can(READ, REPORTS_PAGE) && (
        <Link to="/operator/reports" style={styles.menuLink}>
          <MenuItem>
            <ListItemIcon>
              <List />
            </ListItemIcon>
            <ListItemText inset primary="Reports" />
          </MenuItem>
        </Link>
      )}
    </div>
  );
}

MainMenu.defaultProps = {
  currentWrangler: undefined,
};
MainMenu.propTypes = {
  currentWrangler: PropTypes.shape({
    access: PropTypes.object,
  }),
};

const mapStateToProps = ({ wranglers }) => ({
  currentWrangler: wranglers.currentWrangler,
});

export const BaseMainMenu = MainMenu;
export default connect(mapStateToProps)(MainMenu);
